import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { CustomThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import { PushNotificationsProvider } from "./contexts/PushNotificationsContext";
import { LoaderProvider } from "./contexts/LoaderContext";
import { ProtectedRoute } from "./routes/ProtectedRoute";
import { DashboardLayout } from "./layouts/DashboardLayout";
import { Landing } from "./pages/Landing";
import { Login } from "./pages/Login";
import { Signup } from "./pages/Signup";
import { ForgotPassword } from "./pages/ForgotPassword";
import { Unauthorized } from "./pages/Unauthorized";
import { PublicRoute } from "./routes/PublicRoute";
import Loader from "./components/Loader";

function App() {
  return (
    <CustomThemeProvider>
      <LoaderProvider>
        <CssBaseline />
        <Loader />
        <AuthProvider>
          <PushNotificationsProvider>
            <NotificationProvider>
              <Router>
                <Routes>
                {/* Rutas Públicas */}
                <Route
                  path="/"
                  element={
                    <PublicRoute>
                      <Landing />
                    </PublicRoute>
                  }
                />
                <Route
                  path="/login"
                  element={
                    <PublicRoute>
                      <Login />
                    </PublicRoute>
                  }
                />
                <Route
                  path="/signup"
                  element={
                    <PublicRoute>
                      <Signup />
                    </PublicRoute>
                  }
                />
                <Route
                  path="/forgot-password"
                  element={
                    <PublicRoute>
                      <ForgotPassword />
                    </PublicRoute>
                  }
                />

                {/* Página de acceso denegado */}
                <Route path="/unauthorized" element={<Unauthorized />} />

                {/* Rutas Protegidas del Dashboard */}
                <Route
                  path="/dashboard/*"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout />
                    </ProtectedRoute>
                  }
                />

                {/* Fallback - Redirigir a landing si no está autenticado, o dashboard si lo está */}
                <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Router>
            </NotificationProvider>
          </PushNotificationsProvider>
        </AuthProvider>
      </LoaderProvider>
    </CustomThemeProvider>
  );
}

export default App;
